import React from 'react';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import ColorPicker from 'src/components/Modules-revamp/ColorPicker';
import { Field } from 'src/components/RcForm';
import { useI18n } from 'src/hooks/useRouterChange';
import { sectionProps } from 'src/tools/constant';
import {
  backgroundColor,
  moduleStyle,
} from 'src/tools/contentModulesFieldName';
import { i18nGet } from 'src/tools/tools';
const BackgroundColor = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <Section {...sectionProps}>
      <ItemWrapper title={getI18n('general.backgroundColour')}>
        <Field name={[moduleStyle, backgroundColor]}>
          <ColorPicker disabled={props.disabled} />
        </Field>
      </ItemWrapper>
    </Section>
  );
};
export default BackgroundColor;
